import React, { useEffect, useState } from 'react'
import { supabase } from '../supabaseClient'
import '../styles/Home.css'

// Minimal hand-drawn icon set (no external icon library in this app yet) --
// stroke-only so a single `color` prop on the wrapping chip recolours them.
const ICONS = {
  target: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="4.5" />
      <circle cx="12" cy="12" r="0.75" fill="currentColor" stroke="none" />
    </svg>
  ),
  check: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 12.5l5 5L20 6.5" />
    </svg>
  ),
  noRepeat: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M6 6l12 12" />
    </svg>
  ),
  crown: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 18h18M4 18l-1-9 5 4 4-6 4 6 5-4-1 9" />
    </svg>
  )
}

const LMS_BUBBLES = [
  { icon: 'target', bg: 'var(--blue-dim)', color: 'var(--blue-bright)', title: 'Pick a team', body: "Choose one Premier League team to win their match each gameweek." },
  { icon: 'check', bg: 'var(--green-bg)', color: 'var(--green)', title: 'Win to survive', body: "They win, you're through. A draw or a loss and you're knocked out." },
  { icon: 'noRepeat', bg: 'var(--amber-bg)', color: 'var(--amber)', title: 'Use each team once', body: 'No team twice all season. Spend your big guns wisely.' },
  { icon: 'crown', bg: 'var(--blue-dim)', color: 'var(--blue-bright)', title: 'Last one standing', body: 'Outlast every other player and take the crown.' }
]

export default function Home() {
  const [checking, setChecking] = useState(true)

  useEffect(() => {
    async function check() {
      const { data: { user } } = await supabase.auth.getUser()
      if (user) {
        window.location.href = '/'
      } else {
        setChecking(false)
      }
    }
    check()
  }, [])

  if (checking) return null

  return (
    <div>
      <nav className="topnav">
        <span className="topnav-logo">PREDICTA</span>
        <div style={{ display: 'flex', gap: '8px' }}>
          <a href="/login" className="btn btn-secondary" style={{ padding: '7px 16px', fontSize: '13px' }}>Log in</a>
          <a href="/register" className="btn btn-primary" style={{ padding: '7px 16px', fontSize: '13px' }}>Enter Now</a>
        </div>
      </nav>

      <div style={{ background: 'var(--bg)', minHeight: 'calc(100vh - 58px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '64px 24px', textAlign: 'center' }}>
        <div style={{ maxWidth: '780px', margin: '0 auto' }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', padding: '5px 16px', borderRadius: '20px',
            border: '1px solid var(--blue-border)', background: 'var(--blue-dim)', fontFamily: 'var(--ff-d)',
            fontSize: '11px', fontWeight: '700', letterSpacing: '.12em', textTransform: 'uppercase',
            color: 'var(--blue-bright)', marginBottom: '28px'
          }}>
            Premier League &middot; Last Man Stands
          </div>

          <h1 style={{
            fontFamily: 'var(--ff-d)', fontWeight: '800', fontSize: 'clamp(32px,7vw,56px)', lineHeight: '1.05',
            color: 'var(--text)', marginBottom: '16px', letterSpacing: '-0.01em'
          }}>
            One team a week. Win or you're <span style={{ color: 'var(--red)' }}>out</span>.
          </h1>

          <p style={{ fontSize: '15px', color: 'var(--text-2)', maxWidth: '540px', margin: '0 auto 40px', lineHeight: '1.7' }}>
            The Premier League survival game. Dead simple to play, brutal to last. Outpick your mates week after week, and be the last one standing.
          </p>

          <div className="lms-bubble-grid">
            {LMS_BUBBLES.map(b => (
              <div key={b.title} className="card" style={{ marginBottom: 0 }}>
                <div style={{
                  width: '40px', height: '40px', borderRadius: 'var(--r)', display: 'flex',
                  alignItems: 'center', justifyContent: 'center', background: b.bg, color: b.color, marginBottom: '14px'
                }}>
                  <span style={{ width: '20px', height: '20px', display: 'block' }}>{ICONS[b.icon]}</span>
                </div>
                <div style={{ fontFamily: 'var(--ff-d)', fontWeight: '700', fontSize: '17px', color: 'var(--text)', marginBottom: '6px' }}>
                  {b.title}
                </div>
                <div style={{ fontSize: '13px', color: 'var(--text-2)', lineHeight: '1.5' }}>
                  {b.body}
                </div>
              </div>
            ))}
          </div>

          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap', marginTop: '36px', marginBottom: '14px' }}>
            <a href="/register" className="btn btn-primary" style={{ padding: '15px 36px', fontSize: '16px' }}>Join</a>
            <a href="/how-to-play" className="btn btn-secondary" style={{ padding: '13px 28px', fontSize: '15px' }}>How to play</a>
          </div>
          <p style={{ fontSize: '12px', color: 'var(--text-3)' }}>
            One entry per round &middot; Outlast the field
          </p>
        </div>
      </div>
    </div>
  )
}